import dayjs from 'dayjs';
import { Product } from '@/API';
import { isNumber } from '@/utils/CommonUtils';
import { newPortalDate } from '@/utils/PortalDate';

export const getUrlParam = (key: string, url?: string): string | null => {
  const value = window.location.href.match(
    new RegExp('[?&]' + key + '=(.*?)(&|$|#)')
  );
  if (value == null) return '';
  return decodeURIComponent(value[1]);
};

export const getUrlTarget = (product: Product): string => {
  return product === Product.CJK ? '_blank' : '_self';
};

export const toISOString = (value: number | string | null): string => {
  if (value === null || !isValidDateFormat(value)) {
    return '';
  } else {
    const dateInDayjs = isNumber(value)
      ? dayjs.unix(value as number)
      : dayjs(value);
    return newPortalDate(dateInDayjs, 'YYYY-MM-DD').toString();
  }
};

export const isValidDateFormat = (value: number | string): boolean => {
  if (typeof value === 'string') {
    return (
      checkDateFormatYYYYMMDD(value) ||
      checkDateFormatLocaleDate(value) ||
      checkDateFormatIsoDate(value)
    );
  }
  return true;
};

export const checkDateFormatYYYYMMDD = (date: string) => {
  return checkDateFormat(date, 'YYYYMMDD');
};

export const checkDateFormatLocaleDate = (date: string) => {
  return checkDateFormat(date, 'YYYY/MM/DD');
};

export const checkDateFormatIsoDate = (date: string) => {
  return checkDateFormat(date, 'YYYY-MM-DD');
};

const checkDateFormat = (date: string, format: string) => {
  return dayjs(date, format).format(format) === date;
};

// Return `YYYY/MM/DD`
export const toLocaleString = (value: string | number | null): string =>
  toISOString(value).replace(/-/g, '/');

export const toLocaleDatetimeString = (value: string): string =>
  newPortalDate(dayjs(value), 'YYYY/MM/DD HH:mm:ss').toString();
